"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WithROISelection = void 0;
var mobx_react_1 = require("mobx-react");
var slate_react_1 = require("slate-react");
var slate_1 = require("slate");
var WithROISelection = (0, mobx_react_1.observer)(function (_a) {
    var render = _a.children, element = _a.element, editor = _a.editor, selectionStore = _a.selectionStore;
    var path = slate_react_1.ReactEditor.findPath(editor, element);
    var selection = selectionStore.currentSelection;
    var selected = false;
    if (selection) {
        var startPoint = slate_1.Range.start(selection);
        var endPoint = slate_1.Range.end(selection);
        selected = slate_1.Path.compare(path, startPoint.path) >= 0 && slate_1.Path.compare(path, endPoint.path) <= 0;
    }
    return render({
        selected: selected,
        editorFocussed: selectionStore.focussed,
    });
});
exports.WithROISelection = WithROISelection;
